import { getAuthJson } from "./authStorage";

/** Screens without their own superadmin flag follow the module they depend on. */
const MODULE_ALIASES = {
  statutory: "payroll",
  statutory_reports: "payroll",
  ess_payroll: "payroll",
  ess_attendance: "attendance",
  ess_reports: "reports",
};

/** Superadmin "Module Access Control" flag for the company. Unknown keys stay enabled. */
export function isCompanyModuleEnabled(
  moduleKey,
  companyData = getAuthJson("companyData", null)
) {
  if (!companyData) return true;
  switch (MODULE_ALIASES[moduleKey] || moduleKey) {
    case "employee":
      return Number(companyData.module_employee) !== 0;
    case "attendance":
      return Number(companyData.module_attendance) !== 0;
    case "payroll":
      return Number(companyData.module_payroll) !== 0;
    case "reports":
      return Number(companyData.module_reports) !== 0;
    case "hiring":
      return Number(companyData.module_hiring ?? 1) !== 0;
    case "assets":
      return Number(companyData.module_assets ?? 1) !== 0;
    case "communication":
      return Number(companyData.module_communication ?? 1) !== 0;
    case "helpdesk":
      return Number(companyData.module_helpdesk ?? 1) !== 0;
    default:
      return true;
  }
}

/**
 * Role-management catalog limited to modules the company has switched on in superadmin.
 * Hidden modules keep whatever a role already stores; they just aren't shown or editable.
 */
export function filterCatalogByCompanyModules(
  catalog,
  companyData = getAuthJson("companyData", null)
) {
  return (catalog || []).filter((m) => isCompanyModuleEnabled(m.key, companyData));
}
